import {
	Button,
	Checkbox,
	ClientLogo,
	CopyIcon,
	CycleIcon,
	HighlightedIcon,
	Input,
	IssueIcon,
	Label,
	LaunchIcon,
	Link,
	MailIcon,
	MetricCard,
	Radio,
	RadioGroup,
	RolesIcon,
	ScheduleIcon,
	Search,
	Select,
	TabBar,
	type TabItem,
	TagField,
	Text,
	TextArea,
	Toast,
	UsersIcon,
} from '@viapeople/components'
import { useState } from 'react'
import viteSvg2 from '/logo-grayscale.png'
import viteSvg4 from '/logo-pink.svg'
import viteSvg3 from '/logo-yellow.svg'

export function ComponentsExamples() {
	const [checked, setChecked] = useState(false)
	const [selectedValue, setSelectedValue] = useState('option1')
	const [activeTab, setActiveTab] = useState('1')

	const tabs: TabItem[] = [
		{ id: '1', label: 'Tab 1' },
		{ id: '2', label: 'Tab 2', iconType: 'number', iconValue: 2 },
		{ id: '3', label: 'Tab 3', iconType: 'check' },
		{ id: '4', label: 'Tab 4' },
		{ id: '5', label: 'Tab 5' },
		{ id: '6', label: 'Tab 6' },
		{ id: '7', label: 'Tab 7', disabled: true },
	]

	const handleTabChange = (tabId: string) => {
		setActiveTab(tabId)
	}

	return (
		<div className='p-6'>
			<Text variant='h1' className='mb-8'>
				Component Library
			</Text>
			{/* TODO: update the client logo calls when logo upload development*/}
			<ClientLogo url='https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg' />
			<Toast message='Testing message' position={'bottomLeft'} onClose={() => {}} />
			{/* Typography Section */}
			<section className='mb-12'>
				<Text variant='h2' className='mb-4'>
					Typography
				</Text>
				<div className='grid grid-cols-1 gap-2 p-4 border rounded-lg'>
					<Text variant='h1'>Hello world! (h1)</Text>
					<Text variant='h2'>Hello world! (h2)</Text>
					<Text variant='h3'>Hello world! (h3)</Text>
					<Text variant='h4'>Hello world! (h4)</Text>
					<Text variant='h5'>Hello world! (h5)</Text>
					<Text variant='h6'>Hello world! (h6)</Text>
					<Text variant='large'>Hello world! (large)</Text>
					<Text variant='medium'>Hello world! (medium)</Text>
					<Text variant='small'>Hello world! (small)</Text>
					<Text variant='xsmall'>Hello world! (xsmall)</Text>
					<Text variant='hint'>Hello world! (hint)</Text>
					<Text variant='none'>Hello world! (none)</Text>
				</div>
			</section>
			{/* TabBar Section */}
			<section className='mb-12'>
				<Text variant='h2' className='mb-4'>
					TabBar
				</Text>
				<div className='mt-6 p-4 border rounded-lg'>
					<TabBar tabs={tabs} activeTab={activeTab} onChange={handleTabChange} className='mb-8' />

					<p>Content for Tab {activeTab}</p>
				</div>
			</section>

			<Toast message='Testing message' position={'bottomLeft'} onClose={() => {}} />
			{/* Typography Section */}
			<section className='mb-12'>
				<Text variant='h2' className='mb-4'>
					Client Logo
				</Text>
				<div className='p-4 border rounded-lg'>
					{/* TODO: update the client logo calls when logo upload development*/}
					<ClientLogo url='https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg' />
				</div>
			</section>
			{/* Links Section */}
			<section className='mb-12'>
				<Text variant='h2' className='mb-4'>
					Links
				</Text>
				<div className='p-4 border rounded-lg'>
					<Link href='https://google.com' size='small' withChevron>
						Google (small with chevron)
					</Link>
					<Link variant='breadcrumb' href='https://google.com' withChevron>
						Google (default with chevron)
					</Link>
					<Link href='https://google.com' withChevron>
						Google (default)
					</Link>
					<Link href='https://google.com' disabled withChevron>
						Google (disabled with chevron)
					</Link>
					<Link href='https://google.com' disabled>
						Google (disabled)
					</Link>
				</div>
			</section>
			<section className='mb-12'>
				<Text variant='h2' className='mb-4'>
					Highlighted Icons
				</Text>
				<div className='flex gap-1 justify-center p-4 border rounded-lg'>
					<HighlightedIcon icon={UsersIcon} />
					<HighlightedIcon icon={MailIcon} />
					<HighlightedIcon icon={CopyIcon} />
					<HighlightedIcon icon={IssueIcon} />
					<HighlightedIcon icon={LaunchIcon} />
				</div>
			</section>
			<section className='p-6 flex flex-col items-center'>
				<div className='mb-8'>
					<Text variant='h2' className='mb-4'>
						solid
					</Text>
					<div className='grid grid-cols-3 gap-4'>
						<div className='space-y-4'>
							<Label variant='solid' color='default'>
								Label
							</Label>
							<Label variant='solid' color='default' disabled>
								Label
							</Label>
						</div>
						<div className='space-y-4'>
							<Label variant='solid' color='yellow'>
								Label
							</Label>
							<Label variant='solid' color='yellow' disabled>
								Label
							</Label>
						</div>
						<div className='space-y-4'>
							<Label variant='solid' color='green'>
								Label
							</Label>
							<Label variant='solid' color='green' disabled>
								Label
							</Label>
						</div>
					</div>
				</div>

				<div>
					<Text variant='h2' className='mb-4'>
						outline
					</Text>
					<div className='grid grid-cols-3 gap-4'>
						<div className='space-y-4'>
							<Label variant='outline' color='default'>
								Label
							</Label>
							<Label variant='outline' color='default' disabled>
								Label
							</Label>
						</div>
						<div className='space-y-4'>
							<Label variant='outline' color='yellow'>
								Label
							</Label>
							<Label variant='outline' color='yellow' disabled>
								Label
							</Label>
						</div>
						<div className='space-y-4'>
							<Label variant='outline' color='green'>
								Label
							</Label>
							<Label variant='outline' color='green' disabled>
								Label
							</Label>
						</div>
					</div>
				</div>
			</section>
			{/* Form Controls Section */}
			<section className='mb-12'>
				<Text variant='h2' className='mb-4'>
					Form Controls
				</Text>

				{/* Radio Buttons */}
				<div className='mb-8'>
					<Text variant='h3' className='mb-2'>
						Radio Buttons
					</Text>
					<div className='p-4 border rounded-lg'>
						<RadioGroup name='options' value={selectedValue} onChange={setSelectedValue} size='small' variant='primary'>
							<Radio value='option1' label='Option 1' />
							<Radio value='option2' label='Option 2' />
							<Radio value='option3' label='Option 3' disabled />
						</RadioGroup>
						<RadioGroup name='options' value={selectedValue} onChange={setSelectedValue} size='small' variant='error'>
							<Radio value='option1' label='Option 1' />
							<Radio value='option2' label='Option 2' />
							<Radio value='option3' label='Option 3' disabled />
						</RadioGroup>
					</div>
				</div>

				{/* Checkboxes */}
				<div className='mb-8'>
					<Text variant='h3' className='mb-2'>
						Checkboxes
					</Text>
					<div className='grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded-lg'>
						<div>
							<Text variant='h4' className='mb-2'>
								Primary Variant
							</Text>
							<div className='space-y-2'>
								<Checkbox
									variant='primary'
									size='small'
									label='Small checkbox'
									checked={checked}
									onChange={(e) => setChecked(e.target.checked)}
								/>
								<Checkbox
									variant='primary'
									size='medium'
									label='Medium checkbox'
									checked={checked}
									onChange={(e) => setChecked(e.target.checked)}
								/>
								<Checkbox
									variant='primary'
									size='medium'
									checked={checked}
									onChange={(e) => setChecked(e.target.checked)}
								/>
							</div>
						</div>
						<div>
							<Text variant='h4' className='mb-2'>
								Error Variant
							</Text>
							<div className='space-y-2'>
								<Checkbox
									variant='error'
									size='small'
									label='Small error checkbox'
									checked={checked}
									onChange={(e) => setChecked(e.target.checked)}
								/>
								<Checkbox
									variant='error'
									size='medium'
									label='Medium error checkbox'
									checked={checked}
									onChange={(e) => setChecked(e.target.checked)}
								/>
								<Checkbox
									variant='error'
									size='medium'
									checked={checked}
									onChange={(e) => setChecked(e.target.checked)}
								/>
								<Checkbox variant='error' size='medium' label='Disabled checkbox' disabled />
							</div>
						</div>
					</div>
				</div>

				{/* Card */}
				<div className='mb-8'>
					<Text variant='h3' className='mb-2'>
						Card
					</Text>
					<div className='grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded-lg'>
						<MetricCard icon={RolesIcon} title='Total Roles' value='32' />
						<MetricCard icon={UsersIcon} title='Users' value='312' />
						<MetricCard icon={CycleIcon} title='Cycles' value='12' />
					</div>
				</div>

				{/* Tag Field */}
				<div className='mb-8'>
					<Text variant='h3' className='mb-2'>
						Tag Fields
					</Text>
					<div className='grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded-lg'>
						<TagField placeholder='Basic tag field' />
						<TagField label='With Label' value={[{ id: '', label: 'logo-2.png' }]} />
						<TagField value={[{ id: '', label: 'logo-2.png' }]} hint='Helper text' />
						<TagField
							label='Required Field'
							variant='error'
							value={[{ id: '', label: 'logo-2.png' }]}
							hint='Helper text'
							isRequired
						/>
					</div>
				</div>

				{/* Inputs */}
				<div className='mb-8'>
					<Text variant='h3' className='mb-2'>
						Input Fields
					</Text>
					<div className='grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded-lg'>
						<Input placeholder='Basic input' />
						<Input label='With Label' hint='Helper text' placeholder='Enter text' />
						<Input
							variant='error'
							isRequired
							label='Required Field'
							hint='Error message'
							placeholder='Enter required text'
						/>
						<Input
							variant='default'
							disabled
							label='Disabled Input'
							hint='Disabled helper text'
							showHintIcon
							placeholder='Disabled input'
						/>
						<Input
							variant='default'
							label='With Hint Icon'
							hint='Helper text with icon'
							showHintIcon
							placeholder='Enter text'
						/>
					</div>
				</div>

				{/* Select Dropdown */}
				<div className='mb-8'>
					<Text variant='h3' className='mb-2'>
						Select Dropdowns
					</Text>
					<div className='grid grid-cols-1 md:grid-cols-3 gap-4 p-4 border rounded-lg'>
						<Select
							label='Country'
							showHintIcon
							options={[
								{ value: 'us', label: 'United States' },
								{ value: 'ca', label: 'Canada' },
								{ value: 'mx', label: 'Mexico' },
							]}
							onChange={(value) => console.log(value)}
							hint='Please select your country'
						/>
						<Select
							label='Country'
							variant='error'
							options={[
								{ value: 'us', label: 'United States' },
								{ value: 'ca', label: 'Canada' },
								{ value: 'mx', label: 'Mexico' },
							]}
							onChange={(value) => console.log(value)}
							hint='Error message'
						/>
						<Select
							label='Country'
							variant='error'
							options={[
								{ value: 'us', label: 'United States' },
								{ value: 'ca', label: 'Canada' },
								{ value: 'mx', label: 'Mexico' },
							]}
							onChange={(value) => console.log(value)}
							hint='Disabled dropdown'
							disabled
						/>
					</div>
				</div>

				{/* Search Fields */}
				<div className='mb-8'>
					<Text variant='h3' className='mb-2'>
						Search Fields
					</Text>
					<div className='grid grid-cols-1 md:grid-cols-3 gap-4 p-4 border rounded-lg'>
						<Search placeholder='Search' label='Default Search' hint='Enter keywords to search' showHintIcon={false} />
						<Search
							variant='error'
							placeholder='Search'
							label='Error Search'
							hint='Please enter a valid keyword'
							showHintIcon={false}
						/>
						<Search
							placeholder='Search'
							label='Disabled Search'
							hint='Search is disabled'
							showHintIcon={true}
							disabled
						/>
					</div>
				</div>

				{/* TextArea */}
				<div className='mb-8'>
					<Text variant='h3' className='mb-2'>
						TextArea
					</Text>
					<div className='grid grid-cols-1 md:grid-cols-2 gap-4 p-4 border rounded-lg'>
						<TextArea
							label='Description'
							placeholder='Enter a detailed description'
							hint='Max 250 characters'
							rows={4}
						/>
						<TextArea
							label='Comments'
							placeholder='Add your comments here'
							variant='error'
							hint='This field is required'
							isRequired
							showHintIcon
							rows={4}
						/>
						<TextArea
							label='Feedback'
							placeholder='Disabled textarea'
							hint='You cannot modify this field'
							disabled
							rows={4}
						/>
					</div>
				</div>
			</section>

			{/* Buttons Section */}
			<section className='mb-12'>
				<Text variant='h2' className='mb-4'>
					Buttons
				</Text>
				<div className='space-y-8'>
					{/* Primary Buttons */}
					<div>
						<Text variant='h3' className='mb-2'>
							Primary Buttons
						</Text>
						<div className='flex flex-wrap items-start gap-4 p-4 border rounded-lg'>
							<Button variant='primary' size='small' icon={ScheduleIcon}>
								Small Primary
							</Button>
							<Button variant='primary' size='medium'>
								Medium Primary
							</Button>
							<Button variant='primary' size='medium' disabled icon={ScheduleIcon}>
								Disabled Primary
							</Button>
						</div>
					</div>

					{/* Secondary Buttons */}
					<div>
						<Text variant='h3' className='mb-2'>
							Secondary Buttons
						</Text>
						<div className='flex flex-wrap items-start gap-4 p-4 border rounded-lg'>
							<Button variant='secondary' size='small' icon={ScheduleIcon}>
								Small Secondary
							</Button>
							<Button variant='secondary' size='medium'>
								Medium Secondary
							</Button>
							<Button variant='secondary' size='medium' disabled icon={ScheduleIcon}>
								Disabled Secondary
							</Button>
						</div>
					</div>

					{/* Destructive Buttons */}
					<div>
						<Text variant='h3' className='mb-2'>
							Destructive Buttons
						</Text>
						<div className='flex flex-wrap items-start gap-4 p-4 border rounded-lg'>
							<Button variant='destructive' size='small' icon={ScheduleIcon}>
								Small Destructive
							</Button>
							<Button variant='destructive' size='medium'>
								Medium Destructive
							</Button>
							<Button variant='destructive' size='medium' disabled icon={ScheduleIcon}>
								Disabled Destructive
							</Button>
						</div>
					</div>
				</div>
			</section>

			{/* Images Section */}
			<section className='mb-12'>
				<Text variant='h2' className='mb-4'>
					Images
				</Text>
				<div className='grid grid-cols-1 md:grid-cols-3 gap-4 p-4 border rounded-lg'>
					<div className='flex flex-col items-center'>
						<img src={viteSvg3} alt='Vite SVG 3' className='w-full h-auto' />
						<Text variant='medium' className='mt-2'>
							viteSvg3
						</Text>
					</div>
					<div className='flex flex-col items-center'>
						<img src={viteSvg4} alt='Vite SVG 4' className='w-full h-auto' />
						<Text variant='medium' className='mt-2'>
							viteSvg4
						</Text>
					</div>
					<div className='flex flex-col items-center'>
						<img src={viteSvg2} alt='Vite SVG 2' className='w-full h-auto' />
						<Text variant='medium' className='mt-2'>
							viteSvg2
						</Text>
					</div>
				</div>
			</section>
		</div>
	)
}
